import { useQuery } from '@tanstack/react-query';
import { api } from '../../core/client';
import type { ItsmDashboard } from './site-dashboard.types';

const BASE = '/v1/itsm/dashboard';
const KEY = ['site-dashboard'] as const;

/** The site ITSM operations dashboard (R-146). One aggregate read guarded by
 *  `soc` OR `maintenance` at Read; in cloud mode it routes through the selected
 *  site's `/sites/{id}` proxy like every other `/v1/*` surface. Polls on the
 *  console's 30s cadence. */
export function useItsmDashboard() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<ItsmDashboard>(BASE),
    refetchInterval: 30_000,
  });
}
